<template>
  <div class="box" v-bind="dynamicAttrs">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import './styles.scss';

export default defineComponent({
  name: 'Box',
  props: {
    dynamicAttrs: {},
  },
});
</script>
